// extracted by mini-css-extract-plugin
module.exports = {"LoadingSwitch":"pk_a pz_cv pz_a","LoadingSwitch__init":"pk_b pz_a pz_w pz_j pz_px pz_py pz_fa"};